import { createAccessControl } from "better-auth/plugins/access";
import { adminAc, defaultStatements, memberAc, ownerAc } from "better-auth/plugins/organization/access";
// src/access/platform-access.ts
const PLATFORM_SESSION_HEADER = "x-lawline-platform-session";
const PLATFORM_SESSION_CHANGED = "platform_session_changed";
function platformSessionContext(session) {
	return JSON.stringify([session.id, session.activeOrganizationId ?? null]);
}
const statement = {
	...defaultStatements,
	memory: ["read", "write"],
	apiKey: [
		"create",
		"read",
		"revoke",
		"delete"
	],
	usage: ["read"],
	billing: ["manage"],
	webhook: [
		"create",
		"read",
		"update",
		"delete"
	]
};
const ac = createAccessControl(statement);
const roles = {
	member: ac.newRole({
		...memberAc.statements,
		memory: ["read"],
		apiKey: ["read"],
		usage: ["read"]
	}),
	admin: ac.newRole({
		...adminAc.statements,
		memory: ["read", "write"],
		apiKey: [
			"create",
			"read",
			"revoke",
			"delete"
		],
		usage: ["read"],
		webhook: [
			"create",
			"read",
			"update",
			"delete"
		]
	}),
	owner: ac.newRole({
		...ownerAc.statements,
		memory: ["read", "write"],
		apiKey: [
			"create",
			"read",
			"revoke",
			"delete"
		],
		usage: ["read"],
		billing: ["manage"],
		webhook: [
			"create",
			"read",
			"update",
			"delete"
		]
	})
};
function hasRole(role, name) {
	return role.split(",").some((part) => part.trim() === name);
}
const RANKED = [
	"member",
	"admin",
	"owner"
];
function roleRank(role) {
	return Math.max(-1, ...role.split(",").map((part) => RANKED.indexOf(part.trim())));
}
function canApproveMcp(role) {
	return role.split(",").some((name) => {
		if (!Object.hasOwn(roles, name)) return false;
		return roles[name].authorize({ apiKey: ["create"] }).success === true;
	});
}
export { PLATFORM_SESSION_CHANGED, PLATFORM_SESSION_HEADER, ac, canApproveMcp, hasRole, platformSessionContext, roleRank, roles, statement };

//# sourceMappingURL=platform-access.js.map